module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Regular.61cdcc0fa56f165579633198028833e0.woff";